/*
 * Fowler's Fundraising profit calculator
 * Used by sections/fr-calculator.liquid. All numbers come from the section's
 * theme-editor settings via data attributes; nothing is hard-coded here.
 */
(function () {
  if (window.customElements && customElements.get('fr-calculator')) return;

  var money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
  function fmt(n) { return money.format(Math.round(n)); }

  function fill(template, values) {
    return String(template || '').replace(/\[(\w+)\]/g, function (match, key) {
      return Object.prototype.hasOwnProperty.call(values, key) ? values[key] : match;
    });
  }

  function setFill(range) {
    var min = Number(range.min) || 0;
    var max = Number(range.max) || 100;
    var pct = max > min ? ((Number(range.value) - min) / (max - min)) * 100 : 0;
    range.style.setProperty('--fr-fill', pct + '%');
  }

  /** Returns the index (0-based) of the tier a sales total falls in, or -1 if below the minimum. */
  function tierIndex(tiers, sales) {
    var idx = -1;
    for (var i = 0; i < tiers.length; i++) {
      if (sales >= tiers[i].min) idx = i;
    }
    return idx;
  }

  class FrCalculator extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.boxProfit = Number(this.dataset.boxProfit) || 0;
      try {
        this.tiers = JSON.parse(this.dataset.tiers)
          .map(function (t) { return { min: Number(t.min) || 0, pct: Number(t.pct) || 0 }; })
          .sort(function (a, b) { return a.min - b.min; });
      } catch (e) {
        this.tiers = [{ min: 1500, pct: 15 }, { min: 2500, pct: 30 }, { min: 3750, pct: 35 }, { min: 5000, pct: 40 }];
      }

      this.tabs = Array.prototype.slice.call(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.prototype.slice.call(this.querySelectorAll('[role="tabpanel"]'));
      this.inputs = {
        boxes: this.querySelector('[data-input="boxes"]'),
        students: this.querySelector('[data-input="students"]'),
        value: this.querySelector('[data-input="value"]')
      };

      var self = this;
      this.tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { self.select(tab); });
        tab.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') next = self.tabs[(i + 1) % self.tabs.length];
          if (e.key === 'ArrowLeft') next = self.tabs[(i - 1 + self.tabs.length) % self.tabs.length];
          if (e.key === 'Home') next = self.tabs[0];
          if (e.key === 'End') next = self.tabs[self.tabs.length - 1];
          if (next) { e.preventDefault(); self.select(next); next.focus(); }
        });
      });

      Object.keys(this.inputs).forEach(function (key) {
        var input = self.inputs[key];
        if (!input) return;
        input.addEventListener('input', function () { self.update(); });
      });

      this.update();
    }

    select(tab) {
      this.tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      this.panels.forEach(function (p) {
        p.hidden = p.id !== tab.getAttribute('aria-controls');
      });
    }

    out(name) { return this.querySelector('[data-out="' + name + '"]'); }

    update() {
      var d = this.dataset;
      Object.keys(this.inputs).forEach(function (k) { if (this.inputs[k]) setFill(this.inputs[k]); }, this);

      // Candy bar: profit = boxes × profit per box
      if (this.inputs.boxes) {
        var boxes = Number(this.inputs.boxes.value) || 0;
        this.out('boxes').textContent = boxes;
        this.out('candy-profit').textContent = fmt(boxes * this.boxProfit);
      }

      // Online catalog: sales = students × order value; profit = sales × tier %
      if (!this.inputs.students || !this.inputs.value) return;
      var students = Number(this.inputs.students.value) || 0;
      var value = Number(this.inputs.value.value) || 0;
      var sales = students * value;
      var tiers = this.tiers;
      var idx = tierIndex(tiers, sales);
      var minimum = tiers.length ? tiers[0].min : 0;

      this.out('students').textContent = students;
      this.out('value').textContent = fmt(value);

      var box = this.out('catalog-box');
      var sub = this.out('catalog-sub');
      var nudge = this.out('nudge');

      box.classList.remove('fr-result--none', 'fr-result--tier', 'fr-tier--1', 'fr-tier--2', 'fr-tier--3', 'fr-tier--4');
      Array.prototype.forEach.call(this.querySelectorAll('.fr-tier'), function (pill) {
        pill.classList.toggle('is-active', Number(pill.dataset.tier) === idx + 1);
      });

      if (idx < 0) {
        // Below the program minimum: white box, minimum message, no profit
        box.classList.add('fr-result--none');
        this.out('catalog-profit').textContent = fmt(0);
        sub.textContent = fill(d.msgMin, { minimum: fmt(minimum) });
      } else {
        var tier = tiers[idx];
        box.classList.add('fr-result--tier', 'fr-tier--' + (idx + 1));
        this.out('catalog-profit').textContent = fmt(sales * tier.pct / 100);
        sub.textContent = fill(d.msgTier, { pct: tier.pct });
      }

      // Nudge toward the next tier (or the minimum)
      var nextTier = tiers[idx + 1];
      if (nextTier) {
        var gap = nextTier.min - sales;
        var values = {
          amount: fmt(gap),
          per_student: fmt(Math.ceil(gap / Math.max(students, 1))),
          from: idx >= 0 ? tiers[idx].pct : 0,
          to: nextTier.pct,
          minimum: fmt(minimum),
          pct: idx >= 0 ? tiers[idx].pct : 0
        };
        nudge.textContent = fill(idx < 0 ? d.msgNudgeMin : d.msgNudge, values);
        nudge.hidden = false;
      } else if (idx >= 0) {
        nudge.textContent = fill(d.msgTop, { pct: tiers[idx].pct });
        nudge.hidden = !d.msgTop;
      }
    }
  }

  customElements.define('fr-calculator', FrCalculator);
})();
